// Press feedback for things that aren't buttons — certificate cards, calendar
// days — so they answer on pointer-down like everything else does.
//
// One delegated listener on `root` marks the matched element `data-pressed`
// the instant it is pressed, keeps the mark while the pointer stays within
// the element plus a little padding, drops it when the pointer strays and
// brings it back if it returns, and clears it on release. Purely visual: the
// commit still happens on the native click/change, so nothing double-fires
// and dragging away to cancel works the way a real key does.
const HIT_PADDING = 10 // px

export function pressable(root, selector, { scale = 0.97 } = {}) {
  const onDown = (event) => {
    if (event.button !== undefined && event.button !== 0) return
    const target = event.target.closest(selector)
    if (!target || !root.contains(target)) return

    target.style.setProperty("--press-scale", String(scale))
    target.setAttribute("data-pressed", "")
    target.setAttribute("data-pressable", "")
    try { target.setPointerCapture(event.pointerId) } catch { /* not all targets accept capture */ }

    const rect = target.getBoundingClientRect()
    const inside = (e) =>
      e.clientX >= rect.left - HIT_PADDING && e.clientX <= rect.right + HIT_PADDING &&
      e.clientY >= rect.top - HIT_PADDING && e.clientY <= rect.bottom + HIT_PADDING

    const onMove = (e) => target.toggleAttribute("data-pressed", inside(e))
    const onUp = () => {
      target.removeAttribute("data-pressed")
      target.removeEventListener("pointermove", onMove)
      target.removeEventListener("pointerup", onUp)
      target.removeEventListener("pointercancel", onUp)
      target.removeEventListener("lostpointercapture", onUp)
    }

    target.addEventListener("pointermove", onMove)
    target.addEventListener("pointerup", onUp)
    target.addEventListener("pointercancel", onUp)
    target.addEventListener("lostpointercapture", onUp)
  }

  root.addEventListener("pointerdown", onDown)
  return () => root.removeEventListener("pointerdown", onDown)
}
